<template>
	<div class="container py-5">

		<h1 class="mt-4">{{ $t('login_title') }}</h1>
		<p>{{ $t('login_desciption') }}</p>
		<hr>

		<div class="d-flex flex-column">
			<form @submit.prevent="submitCode">
				<div class="mb-3">
					<!-- <label for="codeInput" class="form-label">{{ $t('classroom_label') }}</label> -->
					<input
						v-model="classroomCode"
						type="text" class="form-control"
						style="width: 10em"
						id="codeInput"
						aria-describedby="codeHelp"
						:placeholder="$t('classroom_input')"
						minlength="3"
						maxlength="10">
					<div id="codeHelp" class="form-text">{{ $t('classroom_hint') }}</div>
				</div>
				<button type="submit" class="btn btn-primary" :disabled="fetchError">{{ $t('login_submit') }}</button>
			</form>
			<div v-if="fetchError">
				<hr>
				<p class="text-danger">{{ fetchErrorMessage }}</p>
			</div>
		</div>
	</div>
</template>



<script>
export default {
	data() {
		return {
			classroomCode: "",
		};
	},

	methods: {
		submitCode() {
			const code = this.classroomCode.toUpperCase();

			// Submit classroom code
			this.fetch(`/api/submit_classroom/${code}`, data => {
				// this.errorMessage = error || data.reason || "";
				if (data && data.success) {

					// Code was accepted, go home
					localStorage.removeItem('exploredCards');
					this.$router.replace({ name: "Home" });
					this.$emit("checkSession");
				}
			});
		},
	},

	computed: {
		// parsedErrorMessage() {
			// return this.$te(this.errorMessage) ? this.$t(this.errorMessage) : this.errorMessage;
		// }
	},

	watch: {
		classroomCode() {
			this.clearFetchError();
		}
	}
};
</script>



<style scoped>
	input[type=text] {
		text-transform: uppercase;
	}

	input::-webkit-input-placeholder {
		text-transform: initial !important;
	}

	input:-ms-input-placeholder {
		text-transform: initial !important;
	}
</style>
